import { render, staticRenderFns } from "./visit.vue?vue&type=template&id=2b9eb5d8&"
import script from "./visit.vue?vue&type=script&lang=js&"
export * from "./visit.vue?vue&type=script&lang=js&"
import style0 from "./visit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports